import { AboutValueCardProps } from '../../interfaces/common'

const AboutValueCard = ({ headerIcon, description, headerText }: AboutValueCardProps) => {
  return (
    <div className="flex flex-col items-center justify-center p-4 sm:p-6 md:p-10">
      <div className="rounded-[10px] bg-[#4950571A] w-[60px] h-[60px] flex items-center justify-center">
        <img src={headerIcon} className="w-6 h-6" alt="header-icon" />
      </div>
      <div className="space-y-5 text-center">
        <h3 className="text-2xl md:text-[24px] leading-10 font-medium">{headerText}</h3>
        <p className="text-[#ADB5BD] font-medium text-[13px] md:text-lg text-center leading-[22px]">
          {description}
        </p>
      </div>
    </div>
  )
}

export default AboutValueCard
